// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 0 !important;
}

.content {
  padding: 1rem;
  margin-bottom: 1rem;
}

.section-title {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #666;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 4px;
  margin: 16px 0 10px 0;
}
.section-title:first-child {
  margin-top: 0;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  flex-wrap: nowrap;
}

.field-label {
  flex: 0 0 150px;
  margin: 0;
  font-size: 0.875rem;
}

.field-value {
  flex: 1 1 auto;
  min-width: 0;
}

.field-value-narrow {
  flex: 0 0 140px;
  min-width: 0;
}

.field-value-select {
  flex: 0 0 160px;
  min-width: 0;
}

.barcode-row {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  gap: 0;
}
.barcode-row input {
  flex: 0 0 200px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/inventory/inventory-dialog/edit-material-dialog/edit-material-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,qBAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,eAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,MAAA;AAAF;AAEE;EACE,eAAA;AAAJ","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 0 !important;\n}\n\n.content {\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.section-title {\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #666;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 4px;\n  margin: 16px 0 10px 0;\n\n  &:first-child {\n    margin-top: 0;\n  }\n}\n\n.field-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n  flex-wrap: nowrap;\n}\n\n.field-label {\n  flex: 0 0 150px;\n  margin: 0;\n  font-size: 0.875rem;\n}\n\n.field-value {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.field-value-narrow {\n  flex: 0 0 140px;\n  min-width: 0;\n}\n\n.field-value-select {\n  flex: 0 0 160px;\n  min-width: 0;\n}\n\n.barcode-row {\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  gap: 0;\n\n  input {\n    flex: 0 0 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
